import { defineComponent as _defineComponent } from 'vue'
import { vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/title.png'
import _imports_1 from '../assets/caidan.png'
import _imports_2 from '../assets/right1.png'
import _imports_3 from '../assets/title_banner.jpg'
import _imports_4 from '../assets/phone1.jpg'
import _imports_5 from '../assets/but1.png'


const _withScopeId = n => (_pushScopeId("data-v-211c1902"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "phone_height" }
const _hoisted_2 = { class: "p-f phone_nav" }
const _hoisted_3 = { class: "d-f j-b phone" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }, null, -1))
const _hoisted_8 = { class: "card-wrap d-f j-b" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_10 = { class: "cff f14 d-f" }
const _hoisted_11 = { class: "p-r" }
const _hoisted_12 = {
  class: "title_banner",
  src: _imports_3
}
const _hoisted_13 = {
  class: "title_banner",
  src: _imports_4
}
const _hoisted_14 = {
  class: "p-a content_install",
  style: {"width":"100%"}
}
const _hoisted_15 = { class: "d-f buts j-c" }
const _hoisted_16 = ["href"]
const _hoisted_17 = { class: "cff f18 d-f j-c" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  alt: ""
}, null, -1))
const _hoisted_19 = ["href"]
const _hoisted_20 = { class: "cff f18 d-f j-c" }
const _hoisted_21 = {
  target: "_blank",
  href: "https://pan.baidu.com/s/1-HYwjiTBAGwcdUHZ3ap-hg?pwd=6q6v"
}
const _hoisted_22 = { class: "cff f18 d-f j-c" }
const _hoisted_23 = { class: "install_ f18 cffs f-w t-c" }
const _hoisted_24 = { class: "install_ f18 cffs f-w" }
const _hoisted_25 = { class: "updeta d-f" }
const _hoisted_26 = { class: "install_tips t-c f18 cffs f-w" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "使用时请安装office2003", -1))

import { ref, onMounted, onUnmounted, nextTick } from "vue";
    import { useRoute } from "vue-router";
    import { showConfirmDialog } from "vant";
    import router from "@/router";
    
export default /*#__PURE__*/_defineComponent({
  __name: 'top',
  props: {
      releasess: Object,
      releasess_: Object,
    },
  setup(__props) {

    const route = useRoute();
    const prop = __props;
    const nav = (path,index) => {
        router.push({
            path: "./"+path,
            query: {
            },
        });
    };
    const windowup = (path,index) => {
      showConfirmDialog({
        title: "提示",
        message: "暂不支持手机下载，请使用电脑打开网站www.xinxikaoshi.com下载安装！",
        showCancelButton:false
      })
      .then(() => {
      })
    };
  const details_show = ref<Number>(false);
  const phoneshow = ref<Number>(false);
  const show = ref<Number>('');
  const screenWidth = ref(window.innerWidth);
  const data = ref({
    oldScrollTop: 0,
  });
  
  const handleResize = () => {
    screenWidth.value = window.innerWidth;
  };
  onMounted(() => {
    if(route.path == '/'){
        show.value = 0
    }else if(route.path == '/cc'){
        show.value = 2
    }else{
        show.value = 1
    }
    if(route.path == '/details'){
        details_show.value= true
    }
    window.addEventListener("scroll", scrolling);
    window.addEventListener('resize', handleResize);
    nextTick(() => {
      document.oncontextmenu = new Function("event.returnValue=false");
      document.onselectstart = new Function("event.returnValue=false");
      document.addEventListener("keydown", function (e) {
        if (e.key == "F12") {
          e.preventDefault(); // 如果按下键F12,阻止事件
        }
      });
    })
  });
  onUnmounted(() => {
    window.removeEventListener("scroll", scrolling);
    window.removeEventListener('resize', handleResize);
  });
  const background = ref(0);
  const scrolling = () => {
    let scrollTop =
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop;
    let scrollStep = scrollTop - data.oldScrollTop;
    if (scrollTop >= 48) {
      background.value = 1;
    } else if (scrollTop <= 48) {
      background.value = 0;
    }
  
  };
  
  
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _withDirectives(_createElementVNode("div", _hoisted_1, null, 512), [
      [_vShow, screenWidth.value < 740]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("img", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (phoneshow.value = !phoneshow.value)),
          src: _imports_1
        })
      ]),
      _createElementVNode("div", {
        class: _normalizeClass([phoneshow.value ? 'option option_' : 'option options'])
      }, [
        _createElementVNode("div", {
          style: _normalizeStyle([{ color: show.value == 0 ? '#01B8E1' : '#333', }, {"border-bottom":"1px solid #E9E9E9"}]),
          onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (nav('',0)), ["stop"])),
          class: "d-f j-b"
        }, [
          _createTextVNode(" 首页/home "),
          _hoisted_5
        ], 4),
        _createElementVNode("div", {
          style: _normalizeStyle([{"border-bottom":"1px solid #E9E9E9"}, { color: show.value == 2 ? '#01B8E1' : '#333', }]),
          onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (nav('cc',2)), ["stop"])),
          class: "d-f j-b"
        }, [
          _createTextVNode(" 云电脑/cloud "),
          _hoisted_6
        ], 4),
        _createElementVNode("div", {
          style: _normalizeStyle({ color: show.value == 1 ? '#01B8E1' : '#333', }),
          onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (nav('support',1)), ["stop"])),
          class: "d-f j-b"
        }, [
          _createTextVNode(" 帮助/help "),
          _hoisted_7
        ], 4)
      ], 2),
      _withDirectives(_createElementVNode("div", {
        onClick: _cache[4] || (_cache[4] = ($event: any) => (phoneshow.value = false)),
        style: {"background":"rgba(0,0,0,0.4)","height":"100vh","width":"100%","position":"fixed","top":"0","left":"0","z-index":"-1"}
      }, null, 512), [
        [_vShow, phoneshow.value]
      ])
    ], 512), [
      [_vShow, screenWidth.value < 740]
    ]),
    _withDirectives(_createElementVNode("div", {
      class: "nav p-f",
      style: _normalizeStyle({
        background: background.value == 0 && !details_show.value ? 'rgba(46, 76, 100, 0)' : '#1A1C38',
      })
    }, [
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", {
            onClick: _cache[5] || (_cache[5] = ($event: any) => (nav('',0))),
            class: _normalizeClass([show.value == 0 ? 'tab p-r ta' : 'ta']),
            style: {"cursor":"pointer"}
          }, "首页", 2),
          _createElementVNode("div", {
            onClick: _cache[6] || (_cache[6] = ($event: any) => (nav('cc',2))),
            class: _normalizeClass([show.value == 2 ? 'tab p-r ta' : 'ta']),
            style: {"cursor":"pointer"}
          }, "云电脑", 2),
          _createElementVNode("div", {
            onClick: _cache[7] || (_cache[7] = ($event: any) => (nav('support',1))),
            class: _normalizeClass([show.value == 1 ? 'tab p-r' : '']),
            style: {"cursor":"pointer"}
          }, "帮助", 2)
        ])
      ])
    ], 4), [
      [_vShow, screenWidth.value > 740]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_11, [
      _withDirectives(_createElementVNode("img", _hoisted_12, null, 512), [
        [_vShow, screenWidth.value > 740]
      ]),
      _withDirectives(_createElementVNode("img", _hoisted_13, null, 512), [
        [_vShow, screenWidth.value < 740]
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("a", {
            href: prop.releasess
          }, [
            _withDirectives(_createElementVNode("div", _hoisted_17, [
              _hoisted_18,
              _createTextVNode(" Windows版下载 ")
            ], 512), [
              [_vShow, screenWidth.value > 740]
            ])
          ], 8, _hoisted_16),
          _createElementVNode("a", {
            href: prop.releasess_
          }, [
            _withDirectives(_createElementVNode("div", _hoisted_20, " 备用下载地址一 ", 512), [
              [_vShow, screenWidth.value > 740]
            ])
          ], 8, _hoisted_19),
          _createElementVNode("a", _hoisted_21, [
            _withDirectives(_createElementVNode("div", _hoisted_22, " 百度网盘下载 ", 512), [
              [_vShow, screenWidth.value > 740]
            ])
          ])
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_23, "安装时，请关闭电脑杀毒软件和防火墙  使用时请安装office2003", 512), [
          [_vShow, screenWidth.value > 740]
        ]),
        _withDirectives(_createElementVNode("div", {
          onClick: _cache[8] || (_cache[8] = ($event: any) => (nav('cc',2))),
          class: "cloud_but f18 d-f j-c"
        }, " 使用云电脑 ", 512), [
          [_vShow, screenWidth.value > 740]
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_24, "云桌面版免环境安装，不限电脑、多平台支持（Windows、mac、ipad/安卓平板）", 512), [
          [_vShow, screenWidth.value > 740]
        ])
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_25, [
        _createElementVNode("div", { onClick: windowup }, "点击下载"),
        _createElementVNode("div", {
          onClick: _cache[9] || (_cache[9] = ($event: any) => (nav('cc',2)))
        }, "进入云电脑")
      ], 512), [
        [_vShow, screenWidth.value < 740]
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_26, [
        _createTextVNode(" 安装时，请关闭电脑杀毒软件和防火墙 "),
        _hoisted_27
      ], 512), [
        [_vShow, screenWidth.value < 740]
      ])
    ], 512), [
      [_vShow, show.value == 0]
    ])
  ]))
}
}

})